import './Footer.css'
import footerLogo from "./logo-white.svg"
import phone from "../images/icon-phone.svg"
import email from "../images/icon-email.svg"
const Footer = () => {
    return (
        <footer>
            <div className="container">
                <div className="flex">
            <div className="footer__logo">
                        <img src={footerLogo} alt="" />
                        
                    
                    <div className="footer__contact email">
                         <img src={email} alt="" />
                        <h5>example@fylo.com
                        </h5>
                    </div>
                   
                        
                    </div>
               
            <div className="footer__links jobs">
                <a href="">About Us</a>
                <a href="">Jobs</a>
                <a href="">Press</a>
                <a href="">Blog</a>
            </div>
             <div className="footer__links">
                <a href="">Contact Us</a>
                <a href="">Terms</a>
                <a href="">Privacy</a>
                <a href="">Policy</a>
            </div> 
             <div className="footer__copyright">
                   <a>&copy; Fylo.All Rights Reserved</a>
                </div> 
               </div>
                </div>
        </footer>
    )
}

export default Footer
